// @flow
export default {
  signIn: 'inscrivez-vous',
  adminSignIn: 'ADMIN PANEL',
  username: 'nom d\'utilisateur',
  password: 'mot de passe',
  company: 'Company',
  forgotPassword: 'Mot de passe oublié ?',
  poweredBy: 'Optimisé par',
  loading: 'Loading...',
  errorMessage: 'L\'identifiant et/ou le mot de passe ne correspondent pas. Veuillez réessayer.',
  errorMustNotEmpty: 'L\'identifiant et/ou le mot de passe doivent être renseignés.',
  inputPhoneForm: {
    inputPhoneNumber: 'INPUT PHONE NUMBER',
    instructionText: 'SMS verification will be sent to your new number.',
    inputYourPhoneNumber: 'Input your phone number',
    submit: 'SUBMIT'
  },
  inputOTPForm: {
    securityCode: 'SECURITY CODE',
    instructionText: 'We have sent an SMS with a unique code to your listed number.',
    confirm: 'CONFIRM',
    smsSentTo: 'SMS Sent to +{0}',
    didNotReceiveSMS: 'Didn\'t receive the SMS?',
    resend: 'Resend',
    error: 'Verify OTP failed, please try again!',
    sending: 'Sending...'
  }
}
